<template>
  <div class="text-center">
    <v-dialog v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Termo
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Nome do Termo*"
                  maxlength="50"
                  outlined
                  counter="50"
                  dense
                  :rules="[(v) => $required(v)]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="6">
                <v-autocomplete
                  v-model="content.tipo"
                  label="Tipo do Termo*"
                  :items="form.lists.tiposDeTermo"
                  :item-text="'descricao'"
                  :item-value="'id'"
                  outlined
                  dense
                  :rules="[(v) => $required(v)]"
                  ></v-autocomplete>
                </v-col>
              <v-col cols="6">
                <v-btn
                  block
                  text
                  color="primary"
                  @click="cadastrarTipoTermo = true"
                >
                  <v-icon class="mr-1">mdi-plus-circle</v-icon>
                  <strong>Adicionar um novo tipo de termo</strong>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <sigfoco-date-picker
                v-model="content.dataInicio"
                label="Data Início*"
                :dataEdicao="content.dataInicio"
                removeIcon
                outlined
                dense
                :rules="[(v) => !!v || 'Campo obrigatório']"
              ></sigfoco-date-picker>
              <sigfoco-date-picker
                v-model="content.dataFim"
                :dataEdicao="content.dataFim"
                label="Data Fim*"
                removeIcon
                outlined
                dense
                :rules="[(v) => !!v || 'Campo obrigatório']"
              ></sigfoco-date-picker>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="12" class="d-flex align-center">
                <div class="mr-4">Ações*:</div>
                <v-radio-group v-if="content" v-model="content.acao.id" row>
                  <div class="d-flex flex-row">
                    <v-radio
                      v-for="n in itemsRadioButtomAcoes"
                      :value="n.id"
                      :key="n.id"
                      :label="n.descricao"
                      class="mr-4"
                    ></v-radio>
                  </div>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <sigfoco-editor-html v-model="content.conteudo"></sigfoco-editor-html>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          @click="salvar"
          @cancel="$emit('onClose')"
          :actionText="'Salvar'"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
    <DialogNovoTipo
      :visible.sync="cadastrarTipoTermo"
      @confirmarNovoTipo="adicionarNovoTipo"
    />
  </div>
</template>
<script>
import DialogNovoTipo from './DialogNovoTipo.vue';
import { DialogProps } from '~/commons/classes/dialog-props';
import { Termo } from '~/commons/classes/termo';
import TermoService from '~/services/manter-termo.service';

export default {
  components: {
    DialogNovoTipo,
  },
  props: new DialogProps(Termo),
  mixins: [TermoService],
  data: () => ({
    form: {
      lists: {
        tiposDeTermo: [],
      },
    },
    cadastrarTipoTermo: false,
  }),
  methods: {
    salvar() {
      const confirmarAcao = (objEnvio) => {
        const mensagem = this.edit ? "a edição" : "o cadastro";
        return this.$swal({
          text: `Confirma ${mensagem} do Termo?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        }).then(() => {
          return this.edit
            ? this.$editarTermo(objEnvio, this.content.id)
            : this.$cadastrarTermo(objEnvio);
        });
      };
      const camposPreenchidos = 
        this.content.nome && 
        this.content.conteudo && 
        this.content.tipo && 
        this.content.acao &&
        this.content.acao.id !== undefined &&
        this.content.acao.id !== null &&
        typeof this.content.acao.id !== 'object';
      if (!camposPreenchidos) {
        return camposPreenchidos 
    ? true 
    : (this.$refs.form.validate(), this.$notifyWarning("Preencha todos os campos obrigatórios!"));
      }
      const tipoTermoId = typeof this.content.tipo === "object" ? this.content.tipo.id : this.content.tipo;
      const objEnvio = {
        nome: this.content.nome,
        conteudo: this.content.conteudo,
        tipoTermoId,
        acaoId: this.content.acao.id,
        dataInicio: this.$formatarDateParaEnviar(this.content.dataInicio),
        dataFim: this.$formatarDateParaEnviar(this.content.dataFim),
      };

      if (objEnvio.dataInicio > objEnvio.dataFim) {
        return this.$notifyWarning("A Data Início não pode ser posterior à Data Final, e a Data Final não pode ser anterior à Data Início.");
      }

      return confirmarAcao(objEnvio).then(({ data }) => {
        this.$notifySuccess(data.mensagem);
        this.$emit("onClose");
        this.$emit("onSave");
      });
    },

    listandoTiposDeTermos() {
      this.$listarTiposDeTermo().then(({ data }) => {
        this.form.lists.tiposDeTermo = data.lista;
      });
    },
    adicionarNovoTipo(tipoNome) {
      this.$cadastrarTipoTermo({ descricao: tipoNome }).then(({ data }) => {
        this.$notifySuccess(data.mensagem);
        this.listandoTiposDeTermos();
      });
    }, 
  },
  mounted() {
    this.listandoTiposDeTermos();
    this.$buscarAcoes({ params: { ativo: true } }).then(({ data }) => {
      this.itemsRadioButtomAcoes = data.lista;
    });
  },
};
</script>

